<section style="margin-top:-80px" fxHide.xs>
        <div #myCarousel class='carousel-slides'>
            <div class="carousel-slide3" fxLayout="row" fxLayoutAlign="start center"  [@fadeInRightBig]="fadeRight(0)" [@fadeInLeftBig]="fadeLeft(0)">
                <div class='slide-text-box' fxLayout='column' fxLayoutAlign="center start" fxFlexOffset="5vw" fxLayoutGap='-10px'>
                    <h1>PREMIER GOLF SOFTWARE</h1>
                    <p>Golf GamesKeeper provides a cloud-based, enterprise level software designed to be simple to use on the front-end and robust on the back-end.
                    </p>
                    <ul>
                        <li>Create and Manage multiple groups</li>
                        <li>Track your handicaps</li>
                        <li>Keep track of games (skins, nassau, etc)</li>
                        <li>Live on-course leaderboard</li>
                    </ul>
                    <div style='height: 40px'></div>
                    <button mat-raised-button class='orange-button small' (click)='register()'>Register Now!</button>
                </div>
            </div>
            <div class="carousel-slide4" fxLayout="row" fxLayoutAlign="start center" [@fadeInRightBig]="fadeRight(1)" [@fadeInLeftBig]="fadeLeft(1)">
                <div fxLayout='column' fxLayoutAlign="center start" class='slide-text-box' fxFlexOffset="5vw" fxLayoutGap='-10px'>
                    <h1>LEAGUE MANAGEMENT SOFTWARE</h1>
                    <P>
                        The Golf GamesKeeper software makes managing your players and their outings simple. Everything you need from start to finish, all in one place.
                    </P>
                    <p>
                        Organizer Benefits:
                    </p>
                    <ul>
                        <li>Personalized Web Portal</li>
                        <li>League and sponsors logos</li>
                        <li>Challenge holes (similar to the Kodak Challenge)</li>
                        <li>Online registration</li>
                        <li>Live TV Leaderboard</li>
                        <li>Ready to go printing material</li>
                        <li>Multi round and Ryder cup ready</li>
                    </ul>

                    <p>
                        Member Benefits:
                    </p>
                    <ul>
                        <li>Full free access to golfgameskeeper.com and GGK mobile app</li>
                        <li>Live Hole-by-Hole Scorecard with Handicaps</li>
                        <li>Score History with Equitable Stroke Control</li>
                    </ul>
                    <div style='height: 40px'></div>
                    <button mat-raised-button class='orange-button large' (click)="scrollToId('product-calculator')">Pick a Plan!</button>
                </div>
            </div>
            <div class="carousel-slide5" fxLayout="row" fxLayoutAlign="start center" [@fadeInRightBig]="fadeRight(2)" [@fadeInLeftBig]="fadeLeft(2)">
                <div fxLayout='column' fxLayoutAlign="center start" class='slide-text-box' fxFlexOffset="5vw" fxLayoutGap='-10px'>
                    <h1>GOLF TRIP READY!</h1>
                    <p>
                        Create your trip, setup a few options, invite your players, schedule your events, pay only just before you play.
                    </p>
                    <p>All you need are player names and email.
                        <br>Golf GamesKeeper will do the rest:</p>
                    <ul>
                        <li>Player notifications</li>
                        <li>Pick from 15,000 courses</li>
                        <li>On course leaderboards</li>
                        <li>Free Golf GamesKeeper Mobile app</li>
                    </ul>
                    <p>Send us your information and we can have your event ready to go today.</p>
                    <div class='' style='padding-top:30px;' fxLayout='column' fxLayoutAlign='center stretch'>
                        <div>
                            <input placeholder="First Name" [(ngModel)]='fName' type='text' />
                        </div>
                        <div>
                            <input placeholder="Last Name" [(ngModel)]='lName' type='text' />
                        </div>
                        <div>
                            <input placeholder="E-mail" [(ngModel)]='email' type='text' />
                            <input placeholder="Phone (10-digit US)" [(ngModel)]='phone' type='tel' />
                            <div *ngIf='registerError' class='error'>{{ registerError }}</div>
                        </div>
                        <div>
                            <button mat-raised-button class='orange-button small' (click)='register()'>Register Now!</button>
                        </div>
                    </div>
                </div>
            </div>
            <button class="rightRs" (click)="nextSlide()">></button>
            <button class="leftRs" (click)="previousSlide()"><</button>
            <ul class="carouselPoint">
                <li *ngFor="let j of slides;" [class.active]="j==currentSlide" (click)="goToSlide(j)"></li>
            </ul>
        </div>
</section>

<!-- <section style="margin-top:-80px;margin-left:-10px">
    <div *ngIf="carouselBanner">
        <ngu-carousel [inputs]="carouselBanner" [dataSource]="carouselTileItems" class='carousel-slides'>
            <ngu-item NguCarouselItem style='width:100vw'>
                <div class="carousel-slide3" fxLayout="row" fxLayoutAlign="start center">
                    <div class='slide-text-box' fxLayout='column' fxLayoutAlign="center start" fxFlexOffset="5vw" fxLayoutGap='-10px'>
                        <h1>PREMIER GOLF SOFTWARE</h1>
                        <p>Golf GamesKeeper provides a cloud-based, enterprise level software designed to be simple to use on the front-end and robust on the back-end.
                        </p>
                        <ul>
                            <li>Create and Manage multiple groups</li>
                            <li>Track your handicaps</li>
                            <li>Keep track of games (skins, nassau, etc)</li>
                            <li>Live on-course leaderboard</li>
                        </ul>
                        <div style='height: 40px'></div>
                        <button mat-raised-button class='orange-button small' (click)='register()'>Register Now!</button>
                    </div>
                </div>
            </ngu-item>
            <ngu-item NguCarouselItem style='width:100vw'>
                <div class="carousel-slide4" fxLayout="row" fxLayoutAlign="start center">
                    <div fxLayout='column' fxLayoutAlign="center start" class='slide-text-box' fxFlexOffset="5vw" fxLayoutGap='-10px'>
                        <h1>LEAGUE MANAGEMENT SOFTWARE</h1>
                        <P>
                            The Golf GamesKeeper software makes managing your players and their outings simple. Everything you need from start to finish, all in one place.
                        </P>
                        <p>
                            Organizer Benefits:
                        </p>
                        <ul>
                            <li>Personalized Web Portal</li>
                            <li>League and sponsors logos</li>
                            <li>Challenge holes (similar to the Kodak Challenge)</li>
                            <li>Online registration</li>
                            <li>Live TV Leaderboard</li>
                            <li>Ready to go printing material</li>
                            <li>Multi round and Ryder cup ready</li>
                        </ul>

                        <p>
                            Member Benefits:
                        </p>
                        <ul>
                            <li>Full free access to golfgameskeeper.com and GGK mobile app</li>
                            <li>Live Hole-by-Hole Scorecard with Handicaps</li>
                            <li>Score History with Equitable Stroke Control</li>
                        </ul>
                        <div style='height: 40px'></div>
                        <button mat-raised-button class='orange-button large' (click)="scrollToId('product-calculator')">Pick a Plan!</button>
                    </div>

                </div>
            </ngu-item>
            <ngu-item NguCarouselItem style='width:100vw'>
                <div class="carousel-slide5" fxLayout="row" fxLayoutAlign="start center">
                    <div fxLayout='column' fxLayoutAlign="center start" class='slide-text-box' fxFlexOffset="5vw" fxLayoutGap='-10px'>
                        <h1>GOLF TRIP READY!</h1>
                        <p>
                            Create your trip, setup a few options, invite your players, schedule your events, pay only just before you play.
                        </p>
                        <p>All you need are player names and email.
                            <br>Golf GamesKeeper will do the rest:</p>
                        <ul>
                            <li>Player notifications</li>
                            <li>Pick from 15,000 courses</li>
                            <li>On course leaderboards</li>
                            <li>Free Golf GamesKeeper Mobile app</li>
                        </ul>
                        <p>Send us your information and we can have your event ready to go today.</p>
                        <div class='' style='padding-top:30px;' fxLayout='column' fxLayoutAlign='center stretch'>
                            <div>
                                <input placeholder="First Name" [(ngModel)]='fName' type='text' />
                            </div>
                            <div>
                                <input placeholder="Last Name" [(ngModel)]='lName' type='text' />
                            </div>
                            <div>
                                <input placeholder="E-mail" [(ngModel)]='email' type='text' />
                                <input placeholder="Phone (10-digit US)" [(ngModel)]='phone' type='tel' />
                                <div *ngIf='registerError' class='error'>{{ registerError }}</div>
                            </div>
                            <div>
                                <button mat-raised-button class='orange-button small' (click)='register()'>Register Now!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ngu-item>
            <button NguCarouselPrev class='leftRs'>&lt;</button>
            <button NguCarouselNext class='rightRs'>&gt;</button>
        </ngu-carousel>
    </div>
</section> -->


<section ngClass.gt-xs='section-desktop' ngClass.lt-sm='section-mobile' fxLayout="row" fxLayoutAlign="center center">
    <div>
        <div fxLayout='row' fxLayout.xs='column' fxLayoutAlign='space-evenly start' fxLayoutAlign.xs='center center'>
            <div class='benefits' fxLayout='column' fxFlex='1 1 25%'>
                <div>
                    <i class='fa fa-bullhorn fa-4x'></i>
                </div>
                <h1 class='benefits-header'>
                    player Notifications
                </h1>
                <div class='benefits-text'>
                    Automated player notification and push notifications, no more emails.
                </div>
            </div>
            <div class='benefits' fxLayout='column' fxFlex='1 1 25%'>
                <div>
                    <i class='fa fa-tv fa-4x'></i>
                    <i class='fa fa-mobile fa-4x'></i>
                </div>
                <h1 class='benefits-header'>
                    realtime results
                </h1>
                <div class='benefits-text'>
                    With Golf GamesKeeper advanced scoring system, know where you stand as you play.
                </div>
            </div>
            <div class='benefits' fxLayout='column' fxFlex='1 1 25%'>
                <div>
                    <i class='fa fa-calculator fa-4x'></i>
                </div>
                <h1 class='benefits-header'>
                    fast and accurate
                </h1>
                <div class='benefits-text'>
                    Get all results as soon as the last person walks in the pro shop. No more complicated spreadsheet and score entering.
                </div>
            </div>
            <div class='benefits' fxLayout='column' fxFlex='1 1 25%'>
                <div>
                    <i class='fa fa-usd fa-4x'></i>
                </div>
                <h1 class='benefits-header'>
                    revenue calculator
                </h1>
                <div class='benefits-text'>
                    Check out our product calculator to see how we can start working for you.
                </div>
            </div>
            <button mat-raised-button class='s18-primary-header-color' style='width:150px' (click)='joinNow()' fxHide fxShow.xs>
                TRY IT FREE
            </button>
        </div>
    </div>
</section>

<!-- <s18-testimonials [fxShow]='showText()' [animate]='showTestimonials'></s18-testimonials> -->

<div id='product-calculator'></div>
<section ngClass.gt-xs='padding-desktop' ngClass.lt-sm='padding-mobile' fxLayout='column' fxLayoutAlign='center center' style='margin-bottom:80px'>
    <h1  class='product-calculator'>PRODUCT CALCULATOR</h1>
    <div fxLayout='row' fxLayout.xs='column' fxLayoutAlign.xs='center center' fxLayoutAlign='space-evenly center' fxLayoutGap='200px'>
        <div style='font-size:200px;text-align:center' fxFlex>
            <div fxLayout="column" fxLayoutAling="center center">
                <i class='fa fa-calculator'></i>
            </div>
        </div>
        <div>
            <mat-card ngClass.gt-xs='calculator-desktop' ngClass.lt-sm='calculator-mobile'>
                <mat-card-title>
                    Please answer a few questions so we can guide you to the right product for you.
                </mat-card-title>
                <mat-card-content style='padding:20px 0px;text-align:center'>
                    <s18-calculator></s18-calculator>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</section>


<div style='height:80px'></div>
<s18-pricing [animate]='showPricing'></s18-pricing>
<s18-mobile-app></s18-mobile-app>
<s18-contact-us></s18-contact-us>
